import Debounce from "./Debounce";
export default class Timeout extends Debounce<null> {
    next() { super.next(null) }
}